import { FC, ChangeEvent } from "react"
import styled from "styled-components"
import { Filter } from "./Filter"
import { Dropdown } from "@components/ui"
import { Color } from "@lib/types"
import DropdownSort from "./DropdownSort";
interface Props {
  filterState: {}
  filters: {
    color: Color[]
    fabricTexture: string[]
    fabricThickness: string[]
    size: string[]
  }
  sortValue: string
  sortOptions: Color[]
  productCount: number
  handleFilterChange: (e: ChangeEvent<HTMLInputElement>) => void
  handleSortChange: (e: ChangeEvent<HTMLSelectElement>) => void
  clearFilters: () => void
}

export const CollectionFilters: FC<Props> = ({
  filters,
  filterState,
  handleFilterChange,
  clearFilters,
  sortValue,
  sortOptions,
  handleSortChange,
  productCount,
}) => {
  return (
    <StyledCollectionFilters>
      <Filter
        filters={filters}
        state={filterState}
        handleChange={handleFilterChange}
        clearFilters={clearFilters}
      >
      <DropdownSort
        value={sortValue}
        options={sortOptions}
        onChange={handleSortChange}
      />
      </Filter>
      <ProductCount>
        {productCount === 1 ? `1 product` : `${productCount} products`}
      </ProductCount>
    </StyledCollectionFilters>
  )
}

const StyledCollectionFilters = styled.div`
  padding: 0 1.7rem;

  @media (min-width: ${({ theme }) => theme.breakpoint.xl}px) {
    padding: 0;
  }
`


const ProductCount = styled.div`
  padding-top: 2rem;
  font-size: 1.2rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  color: ${({ theme }) => theme.color.grey};
`
